<!--content orders-->
<div class="container pt-5 px-lg-0">
	<div class="my-5">
		<div class="text-center mb-2">
			<h1 class="titolo-bertazzoni">APPROVA ORDINI</h1>
		</div>
		<div class="mx-auto col-12 col-md-10 mt-5">
			<div class="d-lg-flex">
				<div class="d-flex justify-content-between">
					<h6 class="mr-4 mb-0">Data ordine:</h6>
					<div class="form-group mb-0 w-100">
						<select class="minimal w-100 rounded-0 border-black" name="anno" [(ngModel)]="filtri.anno" (change)="updateOrders()">
							<option *ngFor="let anno of anni" [value]="anno">{{anno}}</option>
						</select>
					</div>
				</div>
				<div class="ml-lg-5 mt-3 mt-lg-0 d-flex">
					<div class="row no-gutters" style="width: 200px">
						<input
							class="form-bertazzoni white border-right-0 rounded-0"
							type="SEARCH"
							placeholder="SEARCH"
							id=""
							name="parola"
							[(ngModel)]="filtri.parola" />
						<div class="border-left-0 rounded-0 rounded-right form-bertazzoni-search" (click)="filtra()">
							<i class="icon-search font-16"></i>
						</div>
					</div>
				</div>
			</div>

			<div *ngIf="ordiniVisualizzati.length === 0">
				<h5 class="my-5">No order to approve.</h5>
			</div>

			<div class="border border-black mt-4" *ngFor="let ordine of ordiniVisualizzati">
				<div class="bg-black text-white font-12 p-3 accordion-header">
					<div class="row">
						<div class="col-11">
							<div class="row">
								<div class="col-md-4">
									<p class="font-14">
										<span class="font-semibold">Data ordine:</span>
										{{ordine.dataRegistrazioneOrdine | date: 'dd/MM/yy HH:mm'}}
									</p>
								</div>
								<div class="col-md-4">
									<p class="font-14">
										<span class="font-semibold">Ordine Portale Clienti:</span>
										{{ordine.id}}
									</p>
								</div>
								<div class="col-md-4">
									<p class="font-14">
										<span class="font-semibold">Numero AS400:</span>
										<span *ngIf="ordine.confermato">{{trovaNSimag(ordine)}}</span>
									</p>
								</div>
							</div>
							<div class="row">
								<div class="col-md-8">
									<p class="font-14">
										<span class="font-semibold">Indirizzo:</span>
										<span *ngIf="ordine.indirizzo">
											{{ordine.indirizzo.indirizzo}}, {{ordine.indirizzo.localita}} {{ordine.indirizzo.provincia}}, {{ordine.indirizzo.cap}}
										</span>
										<span *ngIf="!ordine.indirizzo">
											{{ordine.utente.cliente.indirizzo}}, {{ordine.utente.cliente.localita}} {{ordine.utente.cliente.provincia}},
											{{ordine.utente.cliente.cap}}
										</span>
									</p>
								</div>
								<div class="col-md-4">
									<p class="font-14">
										<span class="font-semibold">Utente:</span>
										{{ordine.utente.username}}
									</p>
								</div>
							</div>
							<div class="row">
								<div class="col-md-8">
									<p class="font-14">
										<span class="font-semibold">Ragione Sociale:</span>
										{{ordine.utente.cliente.ragioneSociale}}
									</p>
								</div>
								<div class="col-md-4">
									<p class="font-14">
										<span class="font-semibold">ERP Client:</span>
										{{ordine.utente.cliente.codiceCliente}}
									</p>
								</div>
							</div>
							<div class="row">
								<div class="col-md-4">
									<p class="font-14">
										<span class="font-semibold">Quantitá articoli:</span>
										{{ordine.quantita}}
									</p>
								</div>
								<div class="col-md-4">
									<p class="font-14">
										<span class="font-semibold">Totale ordine:</span>
										{{ '' | valuta }} {{totaleOrdine(ordine) | currency:'':''}}
									</p>
								</div>
								<div class="col-md-4">
									<p class="font-14">
										<span class="font-semibold">Totale a listino:</span>
										{{ '' | valuta }} {{totaleOrdineAListino(ordine) | currency:'':''}}
									</p>
								</div>
							</div>
							<div class="row">
								<div class="col-md-4">
									<p class="font-14">
										<span class="font-semibold">Purchase Order:</span>
										{{ordine.rifOrdineCliente}}
									</p>
								</div>
							</div>
						</div>
						<div class="col-1 align-self-center">
							<div class="tasto-accordion" (click)="ordine.feOpen = !ordine.feOpen"></div>
						</div>
					</div>
				</div>
				<div class="p-3 corpo-accordion" *ngIf="ordine.feOpen">
					<div class="row align-items-center mb-4">
						<div class="col-6 col-md-4 mb-3" *ngFor="let item of ordine.prodottiCarrello">
							<p class="text-secondary font-16 mb-2">
								{{item.prodottoCommerciale.codiceCommerciale}}
								<span class="text-black font-semibold" *ngIf="item.prioritario">(Prioritario)</span>
							</p>
							<p class="font-12 mb-1">
								<span class="font-semibold">Prezzo unitario:</span>
								{{ '' | valuta }} {{item.prodottoCommerciale?.listini[0]?.prezzoNetto | currency:'':''}}
							</p>
							<p class="font-12 mb-1">
								<span class="font-semibold">Prezzo unitario all'ordine:</span>
								{{ '' | valuta }} {{item.prezzoUnitarioOriginale | currency:'':''}}
							</p>
							<p class="font-12 mb-2">
								<span class="font-semibold">Quantitá:</span>
								{{item.quantita}}
							</p>
							<p class="mb-2">{{ '' | valuta }} {{(item.quantita * item.prezzoUnitarioOriginale) | number}}</p>
							<hr />
							<p class="font-12 mb-1">
								<span class="font-semibold">Sconto percentuale richiesto:</span>
								{{item.scontoPercentualeRichiesto | number:'':''}}%
							</p>
							<p class="font-12 mb-1">
								<span class="font-semibold">Prezzo scontato richiesto :</span>
								{{ '' | valuta }} {{item.scontoAssolutoRichiesto | currency:'':''}}
							</p>
							<p class="font-12 mb-1">
								<span class="font-semibold">Totale scontato richiesto :</span>
								{{ '' | valuta }} {{item.scontoAssolutoRichiesto * item.quantita | currency:'':''}}
							</p>
							<hr />
							<p class="font-12 mb-1">
								<span class="font-semibold">Sconto discrezionale approvato:</span>
								{{(item.sconto_3_2_approvato | number:'':'') || '/ '}}%
							</p>
							<p class="font-12 mb-1">
								<span class="font-semibold">Prezzo scontato approvato :</span>
								{{ '' | valuta }} {{(item.prezzoScontatoApprovato | currency:'':'') || '/'}}
							</p>
							<p class="font-12 mb-1">
								<span class="font-semibold">Totale scontato approvato :</span>
								{{ '' | valuta }} {{(((item.prezzoScontatoApprovato || '/') * item.quantita) | currency:'':'') || '/'}}
							</p>
						</div>
					</div>

					<div class="row">
						<div class="col-6 text-center align-self-center">
							<p class="font-14">
								<span class="font-semibold mr-2">Data di consegna richiesta:</span>
								{{ordine.dataConsegnaRichiesta | date: 'dd/MM/yy'}}
							</p>
						</div>
						<div class="col-6 text-center">
							<button type="button" class="btn btn-bertazzoni black rounded-0 px-4 ml-3" (click)="editOrder(content, ordine)">
								Modifica sconti
							</button>
							<button
								type="button"
								class="btn btn-bertazzoni black rounded-0 px-4 ml-3"
								(click)="conferma(ordine)"
								*ngIf="!ordine.confermato">
								Approva Ordine
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<ng-template #content let-modal>
	<div class="modal-header">
		<h3 class="modal-title" id="">Modifica sconti</h3>
		<button type="button" class="close" aria-label="Close" (click)="closeModal()">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<table datatable [dtOptions]="dtSettings" class="row-border hover">
			<thead>
				<tr>
					<th>Codice Prodotto</th>
					<th>1/1</th>
					<th>2/1</th>
					<th>3/1</th>
					<th>1/2</th>
					<th>2/2</th>
					<th>3/2</th>
					<th>Prezzo unitario scontato</th>
					<th>Prezzo unitario netto</th>
					<th>Prezzo unitario lordo</th>
					<th></th>
				</tr>
			</thead>
			<tbody *ngIf="selectedOrder.prodottiCarrello.length">
				<tr *ngFor="let product of selectedOrder.prodottiCarrello">
					<td>{{product.prodottoCommerciale.codiceCommerciale}}</td>
					<td>
						<span *ngIf="!product.feEdit || !isAgenteInterno">{{getSconto('1_1', product)}}%</span>
						<input
							*ngIf="product.feEdit && isAgenteInterno"
							type="number"
							min="0"
							class="form-control mb-2 rounded-0 form-bertazzoni white"
							[(ngModel)]="product.sconto_1_1_approvato"
							name="sconto_1_1_approvato{{product.id}}"
							required
							(ngModelChange)="scontoPercentualeApprovatoChange(product)" />
					</td>
					<td>
						<span *ngIf="!product.feEdit || !isAgenteInterno">{{getSconto('2_1', product)}}%</span>
						<input
							*ngIf="product.feEdit && isAgenteInterno"
							type="number"
							min="0"
							class="form-control mb-2 rounded-0 form-bertazzoni white"
							[(ngModel)]="product.sconto_2_1_approvato"
							name="sconto_2_1_approvato{{product.id}}"
							required
							(ngModelChange)="scontoPercentualeApprovatoChange(product)" />
					</td>
					<td>
						<span *ngIf="!product.feEdit || !isAgenteInterno">{{getSconto('3_1', product)}}%</span>
						<input
							*ngIf="product.feEdit && isAgenteInterno"
							type="number"
							min="0"
							class="form-control mb-2 rounded-0 form-bertazzoni white"
							[(ngModel)]="product.sconto_3_1_approvato"
							name="sconto_3_1_approvato{{product.id}}"
							required
							(ngModelChange)="scontoPercentualeApprovatoChange(product)" />
					</td>
					<td>
						<span *ngIf="!product.feEdit || !isAgenteInterno">{{getSconto('1_2', product)}}%</span>
						<input
							*ngIf="product.feEdit && isAgenteInterno"
							type="number"
							min="0"
							class="form-control mb-2 rounded-0 form-bertazzoni white"
							[(ngModel)]="product.sconto_1_2_approvato"
							name="sconto_1_2_approvato{{product.id}}"
							required
							(ngModelChange)="scontoPercentualeApprovatoChange(product)" />
					</td>
					<td>
						<span *ngIf="!product.feEdit || !isAgenteInterno">{{getSconto('2_2', product)}}%</span>
						<input
							*ngIf="product.feEdit && isAgenteInterno"
							type="number"
							min="0"
							class="form-control mb-2 rounded-0 form-bertazzoni white"
							[(ngModel)]="product.sconto_2_2_approvato"
							name="sconto_2_2_approvato{{product.id}}"
							required
							(ngModelChange)="scontoPercentualeApprovatoChange(product)" />
					</td>
					<td>
						<span *ngIf="!product.feEdit">{{getSconto('3_2', product)}}%</span>
						<input
							*ngIf="product.feEdit"
							type="number"
							min="0"
							class="form-control mb-2 rounded-0 form-bertazzoni white"
							[(ngModel)]="product.sconto_3_2_approvato"
							name="sconto_3_2_approvato{{product.id}}"
							required
							(ngModelChange)="scontoPercentualeApprovatoChange(product)" />
					</td>
					<td>
						<span *ngIf="!product.feEdit || !isAgenteInterno">{{ '' | valuta }} {{product.prezzoScontatoApprovato | currency:'':''}}</span>
						<input
							*ngIf="product.feEdit && isAgenteInterno"
							type="number"
							min="0"
							class="form-control mb-2 rounded-0 form-bertazzoni white"
							[(ngModel)]="product.prezzoScontatoApprovato"
							name="prezzoScontatoApprovato{{product.id}}"
							required />
					</td>
					<td>{{ '' | valuta }} {{product.prodottoCommerciale.listini[0].prezzoNetto | currency:'':''}}</td>
					<td>{{ '' | valuta }} {{product.prodottoCommerciale.listini[0].prezzoLordo | currency:'':''}}</td>
					<th>
						<div class="d-flex pl-1">
							<button type="button" class="btn btn-bertazzoni black rounded-0" *ngIf="product.feEdit" (click)="saveProduct(product)">
								SALVA
							</button>
							<img src="assets/img/pencil.svg" class="action-icon" *ngIf="!product.feEdit" (click)="product.feEdit = !product.feEdit" />
						</div>
					</th>
				</tr>
			</tbody>
			<tfoot>
				<tr>
					<td colspan="5">
						Totale ordine scontato richiesto dal cliente:
						<b>{{ '' | valuta }} {{totaleOrdineScontoRichiesto(selectedOrder) | currency:'':''}}</b>
					</td>
					<td colspan="5">
						Totale ordine scontato approvato:
						<b>{{ '' | valuta }} {{totaleOrdineScontoApprovato(selectedOrder) | currency:'':''}}</b>
					</td>
				</tr>
			</tfoot>
		</table>
		<div class="row mt-4">
			<div class="col-md-6 offset-md-6 text-right">
				<button type="button" class="btn btn-bertazzoni black rounded-0 px-4 ml-3" (click)="closeModal()">Chiudi</button>
			</div>
		</div>
	</div>
</ng-template>
